import templateUrl from "emun.auth/login-fieldset.htm";
import config from "emun.auth/auth.config";
import basicController from "servicestack/basic.controller.properties";

const authProviders = {
  emun: "Emun Composite",
  users: "Emun Desktop",
  membership: "Emun B2B",
  credentials: "Emun One",
};

export default {
  templateUrl,
  bindings: {
    request: "<ngModel",
    reverse: "<",
  },
  controller() {
    basicController(this);
    this.authProviders = authProviders;
    this.config = config;
    this.showPassword = false;
    console.debug(templateUrl, this);
  },
};
